export default {"src":"/_next/static/media/gray-room-names.abc48ca0.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};